import React from "react";
import { StyledForbiddenContent, Message } from "./styles";
import { translate } from "../../utils/translations/translate";
import Button from "../UI/Button";
import LockIcon from "@mui/icons-material/Lock";
import { Link } from "react-router-dom";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
const ForbiddenPageContent = () => {
  return (
    <StyledForbiddenContent>
      <LockIcon />
      <Message>
        <h1>{translate("labels.restrictedContent")}</h1>
        <p>{translate("labels.restrictedInfo")}</p>
      </Message>
      <Link to={SITE_LINKS_SCHEMA.DASHBOARD}>
        <Button className="primary-outline" text={translate("labels.goback")} />
      </Link>
    </StyledForbiddenContent>
  );
};

export default ForbiddenPageContent;
